import React, { useRef, useState } from 'react';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';

export default function LeadsTable({ leads, loading, isRepeatLeads = false, isSpeedToLeads = false }) {
    const dt = useRef(null);

    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        full_name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        email: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        phone: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        location_name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        campaign_name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        language_name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        live_assignment: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        count: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
    });

    const srNoBodyTemplate = (rowData, props) => {
        const rowIndex = props.rowIndex + 1;
        return <div className='status'>{rowIndex}</div>;
    };


    function formatDate(inputDate) {
        const dateParts = inputDate.split(' ')[0].split('-');
        const year = dateParts[0];
        const month = dateParts[1];
        const day = dateParts[2];

        const date = new Date(`${year}-${month}-${day}`);

        const monthNames = [
            'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
            'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'
        ];
        const formattedDate = `${parseInt(day)} ${monthNames[date.getMonth()]}, ${year}`;
        return formattedDate;
    }
    // function formatCreatedDate(isoDateString) {
    //     const dateObj = new Date(isoDateString);

    //     // Extract date components
    //     const year = dateObj.getFullYear();
    //     const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    //     const day = String(dateObj.getDate()).padStart(2, '0');

    //     // Extract time components
    //     let hours = dateObj.getHours();
    //     const minutes = String(dateObj.getMinutes()).padStart(2, '0');
    //     const seconds = String(dateObj.getSeconds()).padStart(2, '0');

    //     // Determine AM/PM and adjust hours
    //     const ampm = hours >= 12 ? 'PM' : 'AM';
    //     hours = hours % 12 || 12; // Convert 24-hour to 12-hour format

    //     return `${year}-${month}-${day} ${String(hours).padStart(2, '0')}:${minutes}:${seconds} ${ampm}`;
    // }

    const onGlobalFilterChange = (event) => {
        const value = event.target.value;
        let _filters = { ...filters };

        _filters['global'].value = value;

        setFilters(_filters);
    };

    const createdDateTemplate = (rowData) => {
        const formatedDate = rowData.created_date
        return <div>{formatedDate}</div>
    };

    const openContactPage = (rowData) => {
        return <div>
            <Button onClick={() => window.open(`https://phone.bcrumbs.com/v2/location/${rowData?.location}/contacts/detail/${rowData?.ghl_contact_id}`, '_blank')} label='Contact' icon="pi pi-external-link" />
        </div>
    };

    const exportCSV = (selectionOnly) => {
        dt.current.exportCSV({ selectionOnly });
    };

    const renderHeader = () => {
        const value = filters['global'] ? filters['global'].value : '';

        return (
            <div className='header-container-with-csv-export'>
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText type="search" value={value || ''} onChange={(e) => onGlobalFilterChange(e)} placeholder="Global Search" />
                </span>
                <div className="flex align-items-center justify-content-end gap-2">
                    <Button type="button" icon="pi pi-file" rounded onClick={() => exportCSV(false)} data-pr-tooltip="CSV" />
                </div>
            </div>

        );
    };

    function parseDateFlexible(dateStr) {
        if (!dateStr) return null;
        // Try to parse common American formats with AM/PM
        const dt = new Date(dateStr);
        if (!isNaN(dt.getTime())) return dt;

        // Fallback: replace space before AM/PM → make it more standard
        let cleaned = dateStr.replace(/(\d{1,2}:\d{2}:\d{2})\s+(AM|PM)/i, '$1$2');
        const fallback = new Date(cleaned);
        if (!isNaN(fallback.getTime())) return fallback;

        return null; // or keep as string if parsing fails
    }

    function formatUTCto12hr(isoString) {
        if (!isoString) return "—";
        const d = new Date(isoString);

        const datePart = isoString.slice(0, 10);

        let h = d.getUTCHours();
        const m = String(d.getUTCMinutes()).padStart(2, '0');
        const s = String(d.getUTCSeconds()).padStart(2, '0');

        const period = h < 12 ? 'AM' : 'PM';
        h = h % 12 || 12;

        const timePart = `${String(h).padStart(2, '0')}:${m}:${s} ${period}`;

        return `${datePart} ${timePart}`;
    }

    const latestCountDateTemplate = (rowData) => {
        return (
            <div>
                {formatUTCto12hr(rowData.latest_count_date)}
            </div>
        );
    };

    const header = renderHeader();

    return (
        <div className="card p-fluid">
            <DataTable className="oba-datatable" size='small' ref={dt} value={leads} paginator rows={15} rowsPerPageOptions={[15, 30, 50, 100]} paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink" scrollable scrollHeight="60vh" header={header} filters={filters} loading={loading} onFilter={(e) => setFilters(e.filters)} dataKey="ghl_contact_id" tableStyle={{ minWidth: '50rem' }}
                sortField="created_date" sortOrder={-1}>
                <Column field="full_name" header="Name" frozen style={{ minWidth: 180 }} sortable body={(rowData, options) => (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <span style={{ fontSize: '11px', color: '#7a7a84', flexShrink: 0 }}>#{options.rowIndex + 1}</span>
                        {rowData.full_name}
                    </div>
                )}></Column>
                <Column field="email" header="Email" style={{ minWidth: '2rem' }} sortable ></Column>
                <Column field="phone" header="Phone" style={{ minWidth: '2rem' }} sortable ></Column>
                <Column field="location_name" header="Location" style={{ minWidth: '15rem' }} sortable ></Column>
                <Column field="campaign_name" header="Campaign" style={{ minWidth: '15rem' }} sortable></Column>
                <Column field="language_name" header="Language" style={{ minWidth: '1rem' }} sortable></Column>
                {!isSpeedToLeads && <Column field="live_assignment" header="Live Assignment" style={{ minWidth: '1rem' }} sortable></Column>}
                {!isSpeedToLeads && <Column field="count" header="Count" style={{ minWidth: '1rem' }} sortable></Column>}
                {!isSpeedToLeads && <Column field="app_status" header="App Status" style={{ minWidth: '1rem' }} sortable></Column>}
                {isSpeedToLeads && <Column field="stl_conversation_type" header="Conversion Type" style={{ minWidth: '1rem' }} ></Column>}
                {isSpeedToLeads && <Column field="stl_time_difference" header="Time Difference" style={{ minWidth: '10rem' }} ></Column>}

                {isRepeatLeads && (
                    <Column
                        field="latest_count_date"
                        header="Latest Click Date"
                        body={latestCountDateTemplate}
                        sortable
                        style={{ minWidth: '10rem' }}
                        sortFunction={({ data, field, order }) => {
                            return data.sort((a, b) => {
                                const dateA = parseDateFlexible(a[field]);
                                const dateB = parseDateFlexible(b[field]);

                                if (!dateA && !dateB) return 0;
                                if (!dateA) return order === 1 ? 1 : -1;   // nulls at bottom for asc, top for desc
                                if (!dateB) return order === 1 ? -1 : 1;

                                return order * (dateA.getTime() - dateB.getTime());
                            });
                        }}
                    />
                )}
                
                <Column field="created_date" sortable
                    sortFunction={({ data, field, order }) => {
                        return data.sort((a, b) => {
                            const dateA = parseDateFlexible(a[field]);
                            const dateB = parseDateFlexible(b[field]);
                            if (!dateA) return order === 1 ? -1 : 1;
                            if (!dateB) return order === 1 ? 1 : -1;
                            return order * (dateA - dateB);
                        });
                    }}
                    header="Created Date" style={{ minWidth: '10rem' }} ></Column>
                <Column body={openContactPage} header="Contact" style={{ minWidth: '10rem' }} sortable></Column>
                {/* <Column field="reply_date" header="Replies" style={{ minWidth: '1rem' }} sortable></Column>
                <Column field="pipeline_last_updated_date" header="Oppertunities" style={{ minWidth: '1rem' }} sortable></Column>
                <Column field="pre_approval_date" header="PreApp" style={{ minWidth: '1rem' }} sortable></Column> */}
            </DataTable>
        </div>
    );
}